export const setupAnimations = () => {

	const inViewport = (entries, observer) => {
		entries.forEach((entry) => {
            const animationType = entry.target.dataset.inviewport;
			entry.target.classList.toggle(
				animationType,
				entry.isIntersecting
			)
            entry.target.classList.toggle(
                'visible',
				entry.isIntersecting
            );
		});
	};

	const Obs = new IntersectionObserver(inViewport);
	const obsOptions = {
		rootMargin: '-10px',
	}; //See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options

	const elementsInViewport = document.querySelectorAll('[data-inviewport]');
	elementsInViewport.forEach((el) => {
		Obs.observe(el, obsOptions);
	});

};

// constructor() {
// 	this.end =
// 		'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
// }

// init() {}

// transition(target, animation, phase, endClass) {
// 	$(target)
// 		.addClass([animation, endClass])
// 		.one(this.end, () => {
// 			$(target).removeClass(
// 				phase == 'in' ? animation : [animation, endClass]
// 			);
// 		});
// }
// inInViewAnimations(){
// 	const inViewport = (entries, observer) => {
// 		entries.forEach(entry => {
// 			entry.target.classList.toggle("is-inViewport", entry.isIntersecting);
// 		});
// 	};

// 	const Obs = new IntersectionObserver(inViewport);
// 	const obsOptions = {
// 		rootMargin: '-10px'
// 	}; //See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options

// 	// Attach observer to every [data-inviewport] element:
// 	const ELs_inViewport = document.querySelectorAll('[data-inviewport]');
// 	ELs_inViewport.forEach(EL => {
// 		Obs.observe(EL, obsOptions);
// 	});
// }
